function containsNumber(str?: string | null): boolean {
	return !!str && /\d/.test(str);
}

export default containsNumber;
